module.exports = __webpack_public_path__ + "static/media/SystemsandNetworksLogo.f9ce6fa5.png";